// extracted by mini-css-extract-plugin
module.exports = {"priceWrapper":"DeA_dJLJ"};